import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { Xmark } from "iconoir-react"
import { Link } from "react-router-dom"

import CpatReportAvailable from "./assets/cpat-report-available.webp"

const ReportGenerated = ({
  open,
  handleClose,
  handleDownloadReport,
  reportURL,
}: {
  open: boolean
  handleClose: () => void
  handleDownloadReport: () => void
  reportURL?: string
}) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")
  const Content = (
    <div className="relative rounded-xl p-0">
      <IconButton
        className="absolute right-2 top-2 z-3 size-4 rounded-lg"
        onClick={handleClose}
        autoFocus={false}
        color="white"
        size="sm"
      >
        <Xmark className="!size-2" strokeWidth={2} />
      </IconButton>

      <div className="flex flex-col">
        <div className="relative h-[214px] w-full bg-[linear-gradient(180deg,#0D1753_0%,#121528_47.85%,#14151C_100%)]">
          <div className="absolute size-full  bg-[radial-gradient(300px_at_calc(0%_+_80px)_calc(0%_-_100px),rgba(74,_42,_255,_0.75),transparent_100%),radial-gradient(300px_at_calc(100%_-_180px)_30%,rgba(255,42,184,0.75)_0,transparent_100%),radial-gradient(300px_at_calc(100%_+_150px)_calc(100%_+_150px),rgba(255,123,27,0.75)_0,transparent_100%)]" />
          <img
            src={CpatReportAvailable}
            alt=""
            className="relative z-2 size-full object-contain object-left-bottom"
          />
        </div>
        <div className="p-3">
          <Typography variant="title2" className="mb-1.5">
            Your CPAT report is available
          </Typography>
          <Typography variant="largeBody" className="mb-5">
            You can view or download your CPAT report now.
          </Typography>

          <div className="flex items-center justify-end gap-2">
            <Button
              onClick={handleClose}
              className="bg-[#94A3B81A] text-onSurface-700"
              autoFocus={false}
            >
              Maybe Later
            </Button>
            {reportURL && (
              <Link to={reportURL}>
                <Button color="black" autoFocus onClick={handleDownloadReport}>
                  View Report
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
  if (isSmDown) {
    return (
      <Sheet open={open}>
        <SheetContent height={78} className="!p-0">
          <SheetBody className="!p-0">{Content}</SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        className="!max-w-[461px] overflow-hidden bg-white !p-0"
        aria-describedby="dialog-description"
      >
        {Content}
      </DialogContent>
    </Dialog>
  )
}

export default ReportGenerated
